import { render } from "./ChangeLanguage.vue?vue&type=template&id=928ff488"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__